module.exports = __webpack_public_path__ + "static/media/logo-enele.940822ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-enele.png
// module id = 1661
// module chunks = 0